
import { useState } from 'react';

export default function TestimonialsSection() {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  
  const testimonials = [
    {
      name: 'Amanda J',
      role: 'Satisfied Customer',
      content: 'After seeing a flyer left at my door, I decided to try out Signature Cleaning Services, and I must say, I was pleasantly surprised. Q and his team did an amazing job, and I was thoroughly impressed with their service. They completed the cleaning in a timely manner, leaving my home looking and smelling fantastic. The attention to detail was exceptional, and they exceeded my expectations. I highly recommend Q and his team to anyone looking for a reliable and thorough cleaning service. Thank you for the excellent job!',
      rating: 5
    },
    {
      name: 'Andrea Saavedra',
      role: 'Satisfied Customer',
      content: 'I\'ve only been with this company for 2 months, 2 times cleaning my appt. They are very professional over the phone and text, I have not been able to meet anyone because I am never home when they clean. I think they do a pretty good job at cleaning and organizing the stuff, I have 2 boys, one of them is a newborn and I work full time so I do not have the time to maintain the house all the time. They are a great help for me and the prices are very reasonable. Last time they came they exceed my expectations, i had a bunch of clean clothes that I needed to fold on the couch and they did it for me. Im very happy and I will continue using them as long as I can afford it.',
      rating: 5
    },
    {
      name: 'Kavonte Gardner',
      role: 'Satisfied Customer',
      content: 'Q and Olivia with Signature cleaning services came in on time and got right to work. The team was extremely friendly, prompt, and efficient. I\'d highly recommend.',
      rating: 5
    },
    {
      name: 'Aubrianna Miller',
      role: 'Satisfied Customer',
      content: 'Highly recommend! I was left a flyer in my door and decided to call and inquire and I seriously recommend them! Very professional and efficient and nice people! Q and his team were incredibly nice and went above and beyond! Highly highly recommend!',
      rating: 5
    },
    {
      name: 'Kayla J',
      role: 'Satisfied Customer',
      content: 'I received great service from Anne and Q. Will definitely utilize their services again in the very near future. Thank you so much for keeping my home spic and span!',
      rating: 5
    }
  ];

  const nextTestimonial = () => {
    setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentTestimonial((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section id="testimonials" className="py-20 bg-gradient-to-br from-orange-50 to-peach-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-800 mb-4">What Our Clients Say</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Don't just take our word for it. Here's what our satisfied customers have to say about our cleaning services.
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12 relative">
            <div className="text-center">
              <div className="flex justify-center mb-6">
                {[...Array(testimonials[currentTestimonial].rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-2xl"></i>
                ))}
              </div>
              <blockquote className="text-lg text-gray-700 mb-8 italic leading-relaxed max-w-3xl mx-auto">
                "{testimonials[currentTestimonial].content}"
              </blockquote>
              <div>
                <h4 className="text-xl font-bold text-gray-800">{testimonials[currentTestimonial].name}</h4>
                <p className="text-orange-500 font-medium">{testimonials[currentTestimonial].role}</p>
              </div>
            </div>

            {/* Navigation arrows */}
            {testimonials.length > 1 && (
              <>
                <button
                  onClick={prevTestimonial}
                  className="absolute left-4 top-1/2 transform -translate-y-1/2 w-12 h-12 bg-orange-500 text-white rounded-full flex items-center justify-center hover:bg-orange-600 transition-colors cursor-pointer"
                >
                  <i className="ri-arrow-left-line text-xl"></i>
                </button>
                <button
                  onClick={nextTestimonial}
                  className="absolute right-4 top-1/2 transform -translate-y-1/2 w-12 h-12 bg-orange-500 text-white rounded-full flex items-center justify-center hover:bg-orange-600 transition-colors cursor-pointer"
                >
                  <i className="ri-arrow-right-line text-xl"></i>
                </button>
              </>
            )}
          </div>

          {/* Dots indicator */}
          {testimonials.length > 1 && (
            <div className="flex justify-center mt-8 space-x-2">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentTestimonial(index)}
                  className={`w-3 h-3 rounded-full transition-colors cursor-pointer ${
                    index === currentTestimonial ? 'bg-orange-500' : 'bg-gray-300'
                  }`}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
